import { FeatureToggleClientService } from 'feature-toggle-client';
const ApplicationInsightsErrorTracking = 'application-insights-error-tracking';
export class CoreFeatures {
    static async applicationInsightsLogEnabled() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(ApplicationInsightsErrorTracking);
    }
}
